import { BarChart3 } from 'lucide-react';
import { Card } from 'primereact/card';
import { FC } from 'react';

interface Props {
  title: string;
}

const TeacherDashboardWidgetNoClasses: FC<Props> = ({ title }) => {
  return (
    <Card
      header={
        <h2 className="tw-text-lg tw-p-2 tw-font-bold tw-not-italic tw-border-b-[2px] tw-border-t-[0px] tw-border-x-[0px] tw-border-neutral-100 tw-border-solid">
          {title}
        </h2>
      }
      className="tw-h-full nc_block tw-p-0 tw-my-4 !tw-shadow-none"
    >
      <div className="tw-p-8">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-6">
          <span className="tw-flex tw-p-4 tw-bg-stone-50 tw-rounded-full !tw-rotate-34">
            <BarChart3 size={30} className="tw-text-stone-500" />
          </span>
          <p className="tw-text-gray-600 tw-text-2xl tw-font-atkinson tw-font-bold tw-mb-2">
            No {title} information yet
          </p>
          <p className="tw-text-gray-500 tw-text-sm tw-font-atkinson">Data will appear as students get started</p>
        </div>
      </div>
    </Card>
  );
};

export default TeacherDashboardWidgetNoClasses;
